import PropTypes from "prop-types";
import { Alert, Typography } from "@mui/material";
import DeviceActionDialog from "./DeviceActionDialog";
export default function TogglePowerDialog({
  open,
  onClose,
  onConfirm,
  antenna,
  reader,
  currentStatus,
  togglingPower = {},
}) {
  const known = currentStatus === "Encendida" || currentStatus === "Apagada";
  const turnOff = currentStatus === "Encendida";
  const action = turnOff ? "Apagar antena" : "Encender antena";
  return (
    <DeviceActionDialog
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm(antenna.id, turnOff ? "off" : "on")}
      title={known ? action : "Estado sin verificar"}
      subtitle={antenna?.name || antenna?.rawData?.namepoint}
      actionLabel={action}
      loading={Boolean(antenna && togglingPower[antenna.id])}
      disabled={!antenna?.id || !known || reader?.isOnCooldown}
      fields={[
        ["Antena", antenna?.name || antenna?.rawData?.namepoint || antenna?.rawData?.point],
        ["ID antena", antenna?.id],
        ["Reader", reader?.hostname],
        ["Estado consultado", currentStatus || "Sin verificar"],
      ]}
    >
      <Alert severity={known ? "warning" : "info"}>
        {!known
          ? "Consulta el estado de la antena antes de cambiarlo."
          : reader?.isOnCooldown
          ? "El reader está en tiempo de espera después de un reinicio."
          : `Se enviará la orden de ${turnOff ? "apagar" : "encender"} únicamente a esta antena.`}
      </Alert>
      {known && (
        <Typography variant="body2" sx={{ mt: 2, color: "#475569" }}>
          ¿Deseas continuar?
        </Typography>
      )}
    </DeviceActionDialog>
  );
}
TogglePowerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  antenna: PropTypes.object,
  reader: PropTypes.object,
  currentStatus: PropTypes.string,
  togglingPower: PropTypes.object,
};
